import React, { FC } from 'react';
import { Button } from '../../../../../components/common';
import styles from './ActionItem.scss';
import { IOuter } from './ActionItem.types';

export const ActionItem: FC<IOuter> = ({ icon, label, onClick, dataHook }) => (
  <div className={styles.actionItemButton} data-hook={dataHook}>
    <Button skin="light" prefixIcon={icon} onClick={onClick} dataHook="action-item">
      {label}
    </Button>
  </div>
);
